import React from 'react';

import S from './Messages.module.css';

export const MessagesImg = () => (
  <div className={S.root}>
    <div className={S.bgAngled}></div>
    <div className={S.bulb}></div>
    <div className={S.tail}></div>
    <div className={S.hack}></div>
  </div>
);
